export const mine = {
  applyAccountCancellation: '申请注销账号',
  verifyIdentity: '验证身份',
  accountCancellationSuccess: '注销成功',
  confirmBeforeCancellation: '在注销前，请确认以下内容',
  noAssetsInAccount: '账号无任何资产',
  accountAssetsInclude: '账号资产包括但不限于福昕家装会员、续费关系、设计方案等',
  accountSafe: '账号处于安全状态',
  accountNormal: '账号处于正常使用状态，无被盗风险',
  accountCannotBeRecovered: '账号将不可找回',
  accountCannotLoginAfterCancellation: '账号注销后，账号绑定手机、邮箱等相关信息将被释放，账号无法登录',
  accountCancellationWillAffectOtherProducts: `*注销账号会导致您无法正常使用福昕家装下的其他产品，包括：{content}`,
  content:"智能设计·电脑端、云服务·尊享版、云服务·企业版",
  allDataWillBeDeleted: '注销后账号内所有数据将删除， 且不可恢复！',
  thinkAgain: '再想想',
  confirmCancellation: '确认注销',
  verifyIdentityForSafety: '为了账号安全，请验证身份',
  phoneNumber: '手机号码',
  enterVerificationCode: '请输入验证码',
  getVerificationCode: '获取验证码',
  sendAfterSeconds: '{count}秒后发送',
  cancellationSuccess: '注销成功，感谢您的支持！',
  logoutOnAllDevices: '您的账号稍后在所有设备上将会被登出',
  accountCannotLogin: '账号无法登录',
  bindingInfoCleared: '您的手机、第三方绑定信息已被清空，无法使用这些信息进行登录和找回密码',
  dataDeleted: '您的账号内的数据已被删除，且不可恢复',
  phone: '手机号',
  mine: '我的',
  nextStep: '下一步',
};
